import { createFileRoute } from '@tanstack/react-router'

import { PostEditorPage } from '#/modules/content/post-editor-page'

export const Route = createFileRoute('/_shell/blog-posts/$postId')({
  component: function PostEditorRoute() {
    const { postId } = Route.useParams()
    return <PostEditorPage postId={postId} />
  },
})
